<div class="modal-header">
    <h2 class="modal-title" [innerHTML]="title | translate: { item: '<span class=\'text-primary fw-bold data-hj-suppress\'>' + item + '</span>' }"></h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="deleteItemActionHandler(false)">
    </button>
</div>

<div class="modal-body">
    <span>{{warninglabel}}</span>

    <ul>
        <li class="list-item" *ngFor="let listItem of values; let listItemIndex = index">
            <span>{{listItem}}</span>
        </li>
    </ul>
</div>
  
<div class="modal-footer">
    <button class="btn link-btn" (click)="deleteItemActionHandler(false)">
        <i class="app-icon icon icon-return icon-lg me-2"></i> 
        {{'common.cancel' | translate}}
    </button>
    <button class="btn btn-danger" (click)="deleteItemActionHandler(true)">
        {{'common.delete' | translate}}
    </button>
</div>